import React from 'react';

import { DateTime } from 'luxon';
import { required } from 'react-admin';
import { Box } from '@mui/material';

import SmartDateInput from '../../../../customFields/SmartDateInput';
import isPastDate from '../../../utils/reports/isPastDate';
import FieldBox from '../FieldBox';

function dateRangeValidation(_value: string, allValues: { report: {
  reportDate?: string;
  individualsFrom?: string;
  recordsFrom?: string;
};
}) {
  const {
    reportDate,
    individualsFrom,
    recordsFrom,
  } = allValues.report;
  if (reportDate && individualsFrom) {
    if (DateTime.fromISO(reportDate) < DateTime.fromISO(individualsFrom)) {
      return '"reportDate" date should be after "individualsFrom" date';
    }
  }
  if (reportDate && recordsFrom) {
    if (DateTime.fromISO(reportDate) < DateTime.fromISO(recordsFrom)) {
      return '"reportDate" date should be after "recordsFrom" date';
    }
  }
  return undefined;
}

const PepSanctionHits = () => (
  <Box display="flex" flexDirection="column" gap={4}>
    <FieldBox title="Individuals from *" description="Report will only include individuals created after this date (including).">
      <SmartDateInput
        fullWidth
        label=""
        source="report.individualsFrom"
        validate={[required(), isPastDate, dateRangeValidation]}
        helperText={false}
      />
    </FieldBox>
    <FieldBox title="Records from *" description="Report will only include pep/sanction records created after this date (including).">
      <SmartDateInput
        fullWidth
        label=""
        source="report.recordsFrom"
        validate={[required(), isPastDate, dateRangeValidation]}
        helperText={false}
      />
    </FieldBox>
    <FieldBox title="Report date *" description="Report will only include pep/sanction records and individuals created before this date (excluding).">
      <SmartDateInput
        fullWidth
        label=""
        source="report.reportDate"
        validate={[required(), isPastDate, dateRangeValidation]}
        helperText={false}
      />
    </FieldBox>
  </Box>
);

export default PepSanctionHits;
